<template>
  <div class="summaryBox">
    <div class="summaryBox_head">
      <van-icon
        name="arrow-left"
        color="#333"
        size="20px"
        @click="returnPage"
      />
      <span>收款汇总统计图</span>
      <span></span>
    </div>
    <div style="padding-bottom: 20px">
      <van-pull-refresh
        v-model="isLoading"
        @refresh="onRefresh"
        head-height="150"
        class="refresh"
      >
        <div class="detail">
          <div class="qr_list_top">
            <div>
              <img
                class="qr_top_pic"
                src="../../assets/img/detail_top.png"
                alt=""
              />
              <span class="qr_top_title">今日收款总计</span>
            </div>
            <div class="qr_wx">
              <span class="qr_top_pay">{{ dayPayTotal }}</span>
              元
            </div>
          </div>
          <div class="qr_list_bot">
            <div>
              <img
                class="qr_bot_icon"
                src="../../assets/img/pay_t_icon.png"
                alt=""
              />
              <span class="qr_bot_title">收款总额</span>
            </div>
            <div class="qr_bot_time">
              <span class="qr_bot_money">{{ totalAmt }}</span> 元
            </div>
          </div>
        </div>

        <div class="summaryBox_content">
          <div>
            <div class="summaryBox_content_t">
              <div
                :class="queryInfo.collectType == '2' ? 'isActive' : ''"
                @click="handleTime(2)"
              >
                月
              </div>
              <div
                :class="queryInfo.collectType == '1' ? 'isActive' : ''"
                @click="handleTime(1)"
              >
                年
              </div>
            </div>
            <span class="summaryBox_content_b_s">
              <span>
                <img
                  v-show="queryInfo.collectType == '2'"
                  src="../../assets/qRCode/dd.png"
                  alt
                />
              </span>
              <span>
                <img
                  v-show="queryInfo.collectType == '1'"
                  src="../../assets/qRCode/dd.png"
                  alt
                />
              </span>
            </span>
            <div class="summaryBox_content_b">
              <div
                style="margin-bottom: 6px; height: 40px"
                class="summaryBox_content_b_d"
              >
                <label>日期范围</label>
                <div v-if="queryInfo.collectType == '2'">
                  <input
                    type="text"
                    readonly
                    v-model="timeStr"
                    @click="selectDate"
                  />
                  <img src="@/assets/qRCode/date.png" alt />
                </div>
                <div v-else class="summaryBox_content_b_d1">
                  <input
                    type="text"
                    readonly
                    v-model="sDate"
                    placeholder="请选择"
                    @click="setYear('s')"
                  />
                  <input
                    type="text"
                    readonly
                    v-model="eDate"
                    placeholder="请选择"
                    @click="setYear('e')"
                  />
                </div>
              </div>
            </div>

            <div class="veLine" style="margin-top: 11px">
              <ve-line
                width="100%"
                height="184px"
                :data="chartData"
                :extend="option"
              ></ve-line>
            </div>
          </div>
        </div>
      </van-pull-refresh>
    </div>
    <van-calendar
      ref="Calendar"
      v-model="dateTimeShow"
      :min-date="new Date(1900, 1, 1)"
      @confirm="onConfirmDate"
      :formatter="formatter"
      type="range"
      color="#1989fa"
      class="dayDemo"
    />
    <van-popup v-model="showYear" position="bottom" :style="{ height: '40%' }">
      <van-datetime-picker
        @confirm="confirmMounth"
        @cancel="showYear = false"
        v-model="currentDate"
        type="year-month"
        title="选择年月"
        :formatter="dateformatter"
      />
    </van-popup>
    <!-- 查看详情弹框   -->
    <!-- <DetailDialog
      :show="isShowDetail"
      :list="row"
      @confirm="confirm"
      :showRoadName="true"
    ></DetailDialog>
    <van-popup v-model="showYear" position="bottom" :style="{ height: '40%' }">
      <van-datetime-picker
        @confirm="confirmMounth"
        @cancel="showYear = false"
        v-model="currentDate"
        type="year-month"
        title="选择年月"
        :formatter="dateformatter"
      />
    </van-popup>
    <van-popup v-model="showSelect" position="bottom" class="custom_select">
      <van-picker
        title="选择支付方式"
        show-toolbar
        :columns="tradingTypeOptions"
        @confirm="onConfirmSelect"
        @cancel="showSelect = false"
      />
    </van-popup> -->
  </div>
</template>

<script>
import { formatterDate, formatterDateYM } from "../../utils/common";
import calendar from "@/utils/calendar.js";
import moment from "moment";
export default {
  data() {
    this.option = {
      series: {
        type: "line",
        smooth: true
      },
      backgroundColor: "#fff",
      area: true, // 是否对折线下面进行颜色填充
      legend: {
        show: false
      },
      grid: {
        y: 40,
        top: 40,
        bottom: 10,
        left: 20,
        right: 30,
        containLabel: true
      },
      itemStyle: {
        opacity: 0,
        //面积图颜色设置
        color: {
          type: "linear",
          x: 0,
          y: 0,
          x2: 0,
          y2: 1,
          colorStops: [
            {
              offset: 0,
              color: "rgba(67, 193, 255,0.6)" // 0% 处的颜色
            },
            {
              offset: 1,
              color: "rgba(255, 255, 255,0.6)" // 100% 处的颜色
            }
          ],
          globalCoord: false // 缺省为 false
        }
      },
      xAxis: {
        axisLabel: {
          textStyle: {
            color: "#c4c4c4",
            fontSize: 12
          }
        },
        splitLine: {
          show: false
        }
      },
      yAxis: {
        name: "金额(元)",
        nameTextStyle: {
            color: "#c4c4c4",
            fontSize:"12",
            align:'right',
          },
        axisLabel: {
          textStyle: {
            color: "#c4c4c4",
            fontSize: 12,
            align:'right'
          }
        },
        splitLine: {
          show: false
        },
        position:'left'
      },
      // categoryAxis: {
      //   solitArea: {
      //     show: false
      //   }
      // },
      // chartSettings: {
      //   area: true,
      //   yAxisName: ["金额"]
      // }
    };
    return {
      dateTimeShow: false,
      stateStr: "",
      sDate: `${formatterDateYM(new Date()).split("-")[0]}-01`,
      eDate: "至今",
      chartData: {},
      totalAmt: "",
      dayPayTotal: "",
      roadName: this.$route.query.roadName,
      year: new Date().getFullYear(),
      queryInfo: {
        roadCode: this.$route.query.roadCode,
        deptId: this.$route.query.deptId,
        noticeNo: "",
        sCollectTime: "",
        eCollectTime: "",
        collectType: "2", //固定传值1(年)，2（月）
        page: 1,
        limit: 10
      },
      isLoading: false,
      showTimePopup: false,
      queryForm: [
        { type: "date", label: "开始时间", value: "sCollectTime" },
        { type: "date", label: "结束时间", value: "eCollectTime" }
      ],
      maxDate: new Date(),
      currentDate: new Date(),
      showYear: false,
      timeStr: formatterDateYM(new Date()).split("-")[0] + "-01~至今",
      selectTime: "" //选择是开始时间还是结束时间
    };
  },
  created() {
    this.queryInfo = JSON.parse(this.$route.query.queryInfo);
    this.queryInfo.collectType = "2";
    // this.queryInfo.sCollectTime = "";
    // this.queryInfo.eCollectTime = "";

    this.timeStr = formatterDateYM(new Date()) + "-01~至今";
    this.queryInfo.sCollectTime = moment()
        .startOf("month")
        .format("YYYY-MM-DD");
    this.queryInfo.eCollectTime = moment().format("YYYY-MM-DD");
    this.getReportData();
  },
  destroyed() {},
  methods: {
    dateformatter(type, val) {
      if (type === "month") {
        return `${val}月`;
      } else if (type === "day") {
        return `${val}日`;
      }
      return val;
    },
    formatter(day) {
      const _time = new Date(day.date);
      const y = _time.getFullYear();
      const m = _time.getMonth() + 1;
      const d = _time.getDate();
      const w = _time.getDay();
      const info = calendar.solar2lunar(y, m, d);
      // https://timor.tech/api/holiday/year/
      //   改变周六周日显示颜色
      if (w === 0 || w === 6) {
        day.className = "weekendRed";
      }
      var mm = m;
      mm = m < 10 ? "0" + m : m;
      var dd = d;
      dd = d < 10 ? "0" + d : d;
      // var nowDate = y + "-" + mm + "-" + dd;

      //   优先级:节日>节气>农历
      if (info.festival != null && info.festival != "") {
        day.topInfo = info.festival;
        day.className = "weekendRed";
      }
      return day;
    },
    setYear(str) {
      this.showYear = true;
      this.stateStr = str;
    },
    onConfirmDate(date) {
      this.timeStr = `${formatterDate(date[0])}~${formatterDate(date[1])}`;
      this.dateTimeShow = false;
      this.queryInfo.sCollectTime = formatterDate(date[0]);
      this.queryInfo.eCollectTime = formatterDate(date[1]);
      this.getReportData();
      //   this.getDetailData()
    },
    selectDate() {
      this.dateTimeShow = true;
    },
    onRefresh() {
      this.getReportData();
    },
    returnPage() {
      this.$router.go(-1);
    },
    getReportData() {
      this.request({
        url: "/report/sideParkingPayCollectNoAuth",
        method: "get",
        params: this.queryInfo
      }).then(res => {
        this.isLoading = false;
        if (res.data.code == 1000) {
          this.chartData = res.data.result.eCharts;
          this.totalAmt = Number(res.data.result.totalAmt).toFixed(2);
          this.dayPayTotal = res.data.result.dayPayTotal;
        }
      });
    },
    handleTime(collectType) {
      this.queryInfo.collectType = String(collectType);
      this.queryInfo.sCollectTime = "";
      this.queryInfo.eCollectTime = "";
      if (collectType == "1") {
        this.sDate = `${formatterDateYM(new Date()).split("-")[0]}-01`;
        this.eDate = "至今";
        this.queryInfo.sCollectTime = moment()
          .startOf("year")
          .format("YYYY-MM");
        this.queryInfo.eCollectTime = moment().format("YYYY-MM");
      } else if (collectType == "2") {
        this.timeStr = formatterDateYM(new Date()) + "-01~至今";
        this.queryInfo.sCollectTime = moment()
          .startOf("month")
          .format("YYYY-MM-DD");
        this.queryInfo.eCollectTime = moment().format("YYYY-MM-DD");
      }
      this.getReportData();
    },
    // 计算两个日期的月份差
    calculationMounth() {
      var date1 = this.queryInfo.sCollectTime;
      var date2 = this.queryInfo.eCollectTime;
      // 拆分年月日
      date1 = date1.split("-");
      // 得到月数
      date1 = parseInt(date1[0]) * 12 + parseInt(date1[1]);
      // 拆分年月日
      date2 = date2.split("-");
      // 得到月数
      date2 = parseInt(date2[0]) * 12 + parseInt(date2[1]);
      var m = Math.abs(date1 - date2);
      return m;
    },
    // 选择年月日
    confirmMounth(val) {
      //   this.queryInfo[this.selectTime] = formatterDate(val)
      if (this.stateStr == "s") {
        this.queryInfo.sCollectTime = formatterDateYM(val);
        this.sDate = formatterDateYM(val);
      } else if (this.stateStr == "e") {
        this.queryInfo.eCollectTime = formatterDateYM(val);
        this.eDate = formatterDateYM(val);
      }
      if (
        new Date(this.queryInfo.eCollectTime).getTime() -
          new Date(this.queryInfo.sCollectTime).getTime() <
        0
      ) {
        this.$CDialog({
          confirmBtnText: "确认",
          title: "提示",
          message: "结束日期不能小于开始日期",
          status: "2"
        }).then(() => {
          if (this.stateStr == "s") this.queryInfo.sCollectTime = "";
          if (this.stateStr == "e") this.queryInfo.eCollectTime = "";
        });
        return;
      } else {
        this.getReportData();
        // this.getDetailData()
      }
      this.showYear = false;
    },
    // 计算两个时间此相差的天数
    confirmDay() {
      var firstDate = new Date(this.queryInfo.sCollectTime);
      var secondDate = new Date(this.queryInfo.eCollectTime);
      var diff = Math.abs(firstDate.getTime() - secondDate.getTime());
      var result = parseInt(diff / (1000 * 60 * 60 * 24));
      return result;
    }
    // openDate(val) {
    //   this.showYear = true;
    //   this.selectTime = val;
    //   if (this.queryInfo[val] != "") {
    //     this.currentDate = new Date(this.queryInfo[val]);
    //   }
    // },
    // formatter(type, val) {
    //   if (type === "year") {
    //     return `${val}年`;
    //   } else if (type === "month") {
    //     return `${val}月`;
    //   }
    //   return val;
    // },
    // closePopup() {
    //   if (this.queryInfo.sCollectTime == "") {
    //     Dialog.alert({
    //       title: "错误提示",
    //       message: "请选择开始日期",
    //     }).then(() => {});
    //     return;
    //   }
    //   if (this.queryInfo.eCollectTime == "") {
    //     Dialog.alert({
    //       title: "错误提示",
    //       message: "请选择结束日期",
    //     }).then(() => {});
    //     return;
    //   }
    //   this.showTimePopup = false;
    //   this.timeStr =
    //     this.queryInfo.sCollectTime + "~" + this.queryInfo.eCollectTime;
    //   this.getReportData();
    // },
    // 选择年月
    // confirmYear(val) {
    //   this.queryInfo[this.selectTime] = formatterDateYM(val);
    //   if (
    //     new Date(this.queryInfo.eCollectTime).getTime() -
    //       new Date(this.queryInfo.sCollectTime).getTime() <
    //     0
    //   ) {
    //     Dialog.alert({
    //       title: "错误提示",
    //       message: "结束日期不能小于开始日期",
    //     }).then(() => {});
    //     this.queryInfo[this.selectTime] = "";
    //     return;
    //   }
    //   if (this.calculationMounth() > 12) {
    //     Dialog.alert({
    //       title: "错误提示",
    //       message: "结束日期和开始时间相差不能超过12个月",
    //     }).then(() => {});
    //     this.queryInfo[this.selectTime] = "";
    //     return;
    //   }
    //   this.showYear = false;
    // },
    // 计算两个日期的月份差
    // calculationMounth() {
    //   var date1 = this.queryInfo.sCollectTime;
    //   var date2 = this.queryInfo.eCollectTime;
    //   // 拆分年月日
    //   date1 = date1.split("-");
    //   // 得到月数
    //   date1 = parseInt(date1[0]) * 12 + parseInt(date1[1]);
    //   // 拆分年月日
    //   date2 = date2.split("-");
    //   // 得到月数
    //   date2 = parseInt(date2[0]) * 12 + parseInt(date2[1]);
    //   var m = Math.abs(date1 - date2);
    //   return m;
    // },
    // 选择年月日
    // confirmMounth(val) {
    //   this.queryInfo[this.selectTime] = formatterDate(val);
    //   if (
    //     new Date(this.queryInfo.eCollectTime).getTime() -
    //       new Date(this.queryInfo.sCollectTime).getTime() <
    //     0
    //   ) {
    //     Dialog.alert({
    //       title: "错误提示",
    //       message: "结束日期不能小于开始日期",
    //     }).then(() => {});
    //     this.queryInfo[this.selectTime] = "";
    //     return;
    //   }
    //   this.showYear = false;
    // },
    // 计算两个时间此相差的天数
    // confirmDay() {
    //   var firstDate = new Date(this.queryInfo.sCollectTime);
    //   var secondDate = new Date(this.queryInfo.eCollectTime);
    //   var diff = Math.abs(firstDate.getTime() - secondDate.getTime());
    //   var result = parseInt(diff / (1000 * 60 * 60 * 24));
    //   return result;
    // },
  }
};
</script>

<!-- <style  lang='scss'>
    .summaryBox  .van-nav-bar{
        .van-nav-bar__left  {
            .van-icon{
                color: #333;
            }

        }

    }
    .summaryBox {
        width: 100vw;
        // background: #fff;
        .chartBox {
            height: 90vh;
            overflow-y: scroll;
        }
        .filterBox {
            padding: 0 10px;
            box-sizing: border-box;
            background: transparent;
            justify-content: space-between;
            align-items: center;
            overflow: hidden;
            .filter {
                float: right;
                display: flex;
                align-items: center;
                span {
                    color: #666666;
                }
                .van-icon {
                    color: #0052ee;
                    margin-left: 5px;
                    font-size: 15px;
                }
            }
        }
        .detail {
            padding: 0 10px;
            margin: 10px 0;
            >div {
                display: flex;
                align-items: center;
                margin-bottom: 10px;
                span {
                    font-size: 16px;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #666666;
                }
                h4 {
                    font-size: 20px;
                    font-family: DINAlternate-Bold, DINAlternate;
                    font-weight: bold;
                    color: #FF9458;
                    margin-left: 5px;
                }
                h5 {
                    color: #FF9458;
                }
            }
            >div:nth-of-type(2) {
                span {
                    font-size: 14px;
                }
            }


        }
        .handleMore {
            text-align: center;
            margin-bottom: 10px;
            font-size: 16px;
            color: #A4A4A4;
        }
        .listBox {
            >div {
                display: flex;
                width: 340px;
                height: 78px;
                background: #FFFFFF;
                box-shadow: 1px 4px 10px 0px rgba(137,137,137,0.09);
                border-radius: 6px;
                position: relative;
                left: 50%;
                margin-left: -170px;
                margin-bottom: 10px;
                padding: 15px;
                box-sizing: border-box;
                align-items: center;
                justify-content: space-between;
                >div:nth-of-type(1) {
                    p {
                        font-size: 16px;
                        font-family: PingFangSC-Semibold, PingFang SC;
                        font-weight: 600;
                        color: #333333;
                        margin-bottom: 10px;
                    }
                    div {
                        display: flex;
                        align-items: center;
                        font-size: 14px;
                        font-family: PingFangSC-Regular, PingFang SC;
                        font-weight: 400;
                        color: #A4A4A4;
                        span {
                            margin-left: 5px;
                        }
                    }
                }
                >div:nth-of-type(2) {
                    width: 110px;
                    text-align: center;
                    border-left: 1px solid #ECECEC;
                    p {
                        font-size: 18px;
                        font-family: PingFangSC-Semibold, PingFang SC;
                        font-weight: 600;
                        color: #0E85FF;
                        margin-bottom: 10px;
                    }
                    span {
                        font-size: 12px;
                        font-family: PingFangSC-Regular, PingFang SC;
                        font-weight: 400;
                        color: #999999;
                    }
                }
            }
        }
        .searchBox {
            position: relative;
            padding: 60px 16px 0 16px;
            height: 100vh;
            box-sizing: border-box;
            h4 {
                font-size: 14px;
                font-family: PingFangSC-Semibold, PingFang SC;
                font-weight: 600;
                color: #333333;
                margin-bottom: 10px;
            }
            input {
                width: 290px;
                height: 44px;
                background: #FFFFFF;
                border-radius: 2px;
                border: 1px solid #E1E1E1;
                font-size: 16px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #BBBBBB;
                padding: 10px;
                box-sizing: border-box;
                margin-bottom: 16px;
            }
            .btnBox {
                display: flex;
                >div {
                    margin-right: 8px;
                    .van-button {
                        width: 141px;
                        height: 44px;
                        border-radius: 2px;
                        line-height: 44px;
                        text-align: center;
                    }
                }
            }
            .bottomBtn {
                height: 53px;
                display: flex;
                width: 100%;
                position: absolute;
                bottom: 0;
                left: 0;
                >div  {
                    width: 50%;
                    text-align: center;
                    font-size: 16px;
                    line-height: 53px;
                }
                >div:nth-of-type(1) {
                    border-top: 1px solid #E1E1E1;
                    color: #4D4D4D;
                }
                >div:nth-of-type(2) {
                    background: #0E85FF;
                    color: #fff;
                }
            }
        }
        .fillter {
            display: flex;
            align-items: center;
            width: 100vw;
            justify-content: space-between;
            padding: 0 10px;
            box-sizing: border-box;
            margin-bottom: 10px;
            >div:nth-of-type(1) {
                display: flex;
                height: 25px;
                align-items: center;
                border-radius: 3px;
                overflow: hidden;
                box-sizing: border-box;
                >div {
                    width: 60px;
                    height: 23px;
                    text-align: center;
                    line-height: 23px;
                    border: 1px solid #409EFF;
                    font-size: 16px;
                }
                .active {
                    background: #409EFF;
                    color: #fff;
                }
            }
            >div:nth-of-type(2) {
                font-size: 14px;
            }
        }
    }
</style> -->
<style lang='scss' scoped>
.custom_select {
  .van-picker__confirm {

    font-size: 16px;
    color: #208fff;
    letter-spacing: 0;
    font-weight: 500;
  }
  .van-picker__cancel {

    font-size: 16px;
    color: #464a4c;
    letter-spacing: 0;
    font-weight: 500;
  }
}
.isActive {
  margin-top: -15px;
  line-height: 42px !important;
  font-size: 16px !important;
  color: #464a4c !important;
  background: #a9e2ff !important;
}
.summaryBox_content {
  margin: 0 15px;
  margin-top: 60px;
  height: 280px;
  background: #ffffff;
  border-radius: 10px;
  position: relative;
  z-index: 2;
  > div {
    position: relative;
    height: 100%;
    background: #fff;
    border-radius: 10px;
    padding-top: 30px;
  }

  .summaryBox_content_t {
    position: absolute;
    width: 100%;
    top: -22px;
    display: flex;
    z-index: -1;
    div {
      width: 49%;
      min-height: 44px;
      text-align: center;
      line-height: 27px;

      font-size: 11px;
      color: #464a4c;
      letter-spacing: 0;
      font-weight: 400;
      //   box-shadow: 0px 0px 8px 0px rgba(18, 121, 226, 0.7);
      border-radius: 8px 8px 0px 0px;
      background: #d4e3ff;
      position: relative;
      span {
        position: absolute;
        z-index: 20;
        top: 30px;
        img {
          width: 30px;
        }
      }
    }
    //  div::after{
    //     content: 'wenzi';
    //     position: absolute;
    //  }
    div:nth-of-type(1) {
      margin-right: 12px;
    }
  }
  .summaryBox_content_b {
    margin: 0 20px;
    div:last-child {
      display: flex;
      label {

        font-size: 14px;
        color: #464a4c;
        letter-spacing: 0;
        text-align: right;
        font-weight: 500;
        line-height: 36px;
        white-space: nowrap;
      }
      div {
        width: 224px;
        height: 36px;
        line-height: 36px;
        border-radius: 4px;
        margin-left: 12px;
        input {
          outline: none;
          width: 100%;

          font-size: 14px;
          color: #464a4c;
          letter-spacing: 0;
          text-align: center;
          font-weight: 400;
          &::placeholder {

            font-size: 14px;
            color: #cccccc;
            letter-spacing: 0;
            text-align: right;
            font-weight: 400;
          }
        }
      }
      .tb {
        line-height: 35px !important;
        margin-left: 7px !important;
      }
    }
    .summaryBox_content_b_d {
      display: flex;
      label {

        font-size: 14px;
        color: #464a4c;
        letter-spacing: 0;
        text-align: right;
        font-weight: 500;
        line-height: 36px;
      }
      div {
        width: 224px;
        height: 36px;
        line-height: 36px;
        border: 1px solid rgba(204, 204, 204, 1);
        border-radius: 4px;
        display: flex;
        margin-left: 12px;
        input {
          outline: none;
          border-right: 1px solid rgba(204, 204, 204, 1);
          text-align: center;
          flex: 1;
          background: #fafafa;
        }

        img {
          width: 15px;
          height: 15px;
          padding: 10px;
        }
      }
    }
    .summaryBox_content_b_d1 {
      display: flex;
      justify-content: space-around;
      border: 0 !important;
      input {
        width: 47%;
        border: 0 !important;
        border: 1px solid #cccccc !important;
        &::placeholder {

          font-size: 14px;
          color: #cccccc;
          letter-spacing: 0;
          text-align: center;
          font-weight: 400;
        }
      }
      input:nth-of-type(1) {
        margin-right: 10px;
      }
    }
  }
}
.summaryBox_content_b_s {
  display: flex;
  justify-content: space-between;
  position: absolute;
  width: 100%;
  top: 0px;
  span {
    display: block;
    width: 49%;
    img {
      width: 100%;
      height: 30px;
      margin: 0 auto;
      display: block;
    }
  }
}
.summaryBox .van-nav-bar {
  .van-nav-bar__left {
    .van-icon {
      color: #333;
    }
  }
}
.summaryBox {
  ::v-deep .weekendRed {
    color: #ee0a24 !important;
  }
  .van-ellipsis {
    color: #fff !important;

    font-size: 14px;
    color: #ffffff;
    letter-spacing: 0;
    font-weight: 500;
  }
  .van-picker-column__item {
    .van-ellipsis {
      color: #333 !important;

      font-size: 14px;
      letter-spacing: 0;
      font-weight: 500;
    }
  }
  .van-dropdown-menu__title::after {
    border-color: transparent transparent #fff #fff !important;
    opacity: 1 !important;
  }
  .van-dropdown-menu__title--active::after {
    border: transparent transparent #fff #fff !important;
  }
  .van-dropdown-item__option--active {
    .van-cell__title {
      span {
        color: #208fff;
      }
    }
  }
  .van-cell__value {
    i {
      font-weight: 900;
      font-size: 22px;
    }
  }

  .van-cell__title {
    span {

      font-size: 14px;
      color: #464a4c;
      letter-spacing: 0;
      font-weight: 400;
    }
  }
}
.summaryBox_head {
  height: 44px;
  // text-align: center;
  line-height: 44px;
  font-family: PingFangSC-Semibold;
  font-size: 17px;
  letter-spacing: 0;
  text-align: center;
  font-weight: 600;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 15px;
  background: #fff;

  font-size: 17px;
  color: #333333;
  letter-spacing: 0;
  text-align: center;
  font-weight: 500;
}
.summaryBox {
  width: 100vw;
  //   background: url("../../assets/qRCode/bj.png") 0 0 no-repeat;
  //   background-size: 100% 100%;
  background: #f3f3f3;
  .filterBox {
    padding: 0 15px;
    box-sizing: border-box;
    background: transparent;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .van-dropdown-menu__bar {
      box-shadow: none;
      background: transparent;
    }
    .filter {
      display: flex;
      align-items: center;
      span {

        font-size: 14px;
        color: #ffffff;
        letter-spacing: 0;
        font-weight: 500;
      }
      .van-icon {
        color: #333;
        margin-left: 5px;
        font-size: 15px;
      }
    }
  }
  .detail {
    height: 130px;
    width: 345px;
    background: url("../../assets/qRCode/cxbj.png") 0 0 no-repeat;
    background-size: 100% 100%;
    margin: 0 auto;
    margin-top: 8px;
    // padding: 14px 15px 13px 15px;
    padding: 0px 20px;
    box-sizing: border-box;
    h2 {

      font-size: 14px;
      color: #4d5155;
      letter-spacing: 0;
      font-weight: 400;
      margin-bottom: 8px;
    }
    .detail_b {
      display: flex;
      align-items: self-end;
      padding-bottom: 12px;
      border-bottom: 1px solid #c9c9c9;
      margin-bottom: 18px;
      h4 {

        font-size: 32px;
        color: #208fff;
        letter-spacing: 0;
        font-weight: 500;
        line-height: 33px;
        margin-right: 6px;
      }
      span {

        font-size: 12px;
        color: #4d5155;
        letter-spacing: 0;
        font-weight: 400;
        line-height: 20px;
      }
    }
    .detail_f {
      display: flex;
      align-items: baseline;
      span {

        font-size: 14px;
        color: #4d5155;
        letter-spacing: 0;
        font-weight: 400;
      }
      span:nth-of-type(2) {
        margin-left: 10px;

        font-size: 20px;
        color: #4d5155;
        letter-spacing: 0;
        line-height: 27px;
        font-weight: 400;
      }
    }
  }
  //   .veLine {
  //       height: 184px;
  //       .ve-line {
  //           height: 184px;
  //       }
  //   }
  .listBox {
    > div {
      display: flex;
      width: 340px;
      height: 78px;
      background: #ffffff;
      box-shadow: 1px 4px 10px 0px rgba(137, 137, 137, 0.09);
      border-radius: 6px;
      position: relative;
      left: 50%;
      margin-left: -170px;
      margin-bottom: 10px;
      padding: 15px;
      box-sizing: border-box;
      align-items: center;
      justify-content: space-between;
      > div:nth-of-type(1) {
        p {
          font-size: 16px;
          font-family: PingFangSC-Semibold, PingFang SC;
          font-weight: 600;
          color: #333333;
          margin-bottom: 10px;
        }
        div {
          display: flex;
          align-items: center;
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #a4a4a4;
          span {
            margin-left: 5px;
          }
        }
      }
      > div:nth-of-type(2) {
        width: 110px;
        text-align: center;
        border-left: 1px solid #ececec;
        p {
          font-size: 18px;
          font-family: PingFangSC-Semibold, PingFang SC;
          font-weight: 600;
          color: #0e85ff;
          margin-bottom: 10px;
        }
        span {
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #999999;
        }
      }
    }
  }
  .searchBox {
    position: relative;
    padding: 60px 16px 0 16px;
    height: 100vh;
    box-sizing: border-box;
    h4 {
      font-size: 14px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #333333;
      margin-bottom: 10px;
    }
    input {
      width: 290px;
      height: 44px;
      background: #ffffff;
      border-radius: 2px;
      border: 1px solid #e1e1e1;
      font-size: 16px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #bbbbbb;
      padding: 10px;
      box-sizing: border-box;
      margin-bottom: 16px;
    }
    .btnBox {
      display: flex;
      > div {
        margin-right: 8px;
        .van-button {
          width: 141px;
          height: 44px;
          border-radius: 2px;
          line-height: 44px;
          text-align: center;
        }
      }
    }
    .bottomBtn {
      height: 53px;
      display: flex;
      width: 100%;
      position: absolute;
      bottom: 0;
      left: 0;
      > div {
        width: 50%;
        text-align: center;
        font-size: 16px;
        line-height: 53px;
      }
      > div:nth-of-type(1) {
        border-top: 1px solid #e1e1e1;
        color: #4d4d4d;
      }
      > div:nth-of-type(2) {
        background: #0e85ff;
        color: #fff;
      }
    }
  }
}
.refresh {
  //   height: 95vh;
  height: 90vh;
  //   overflow-y: scroll;
  ::v-deep .van-loading__text {
    color: #999 !important;
  }
  ::v-deep .van-pulling__text {
    color: #999 !important;
  }
  ::v-deep .van-pull-refresh__head {
    color: #999 !important;
  }
  ::v-deep .van-loosing__text {
    color: #999 !important;
  }
}
.handleMore {
  text-align: center;
  padding-bottom: 20px;
  font-size: 16px;
  color: #a4a4a4;
}

.qr_list {
  width: 345px;
  height: 130px;
  margin: 0 auto;
  margin-bottom: 10px;
  background: #fff;
  border-radius: 10px;
  padding: 0px 20px;
  box-sizing: border-box;
}
.qr_list_top {
  padding-top: 30px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #f2f2f2;
  padding-bottom: 30px;
  .qr_top_pic {
    width: 22px;
  }
  .qr_top_title {

    font-size: 20px;
    color: #4d5155;
    letter-spacing: 0;
    font-weight: 500;
    margin-left: 10px;
  }
  .qr_wx {
    font-size: 14px;
    display: flex;
    align-items: center;
    .qr_top_pay {
      margin: 0px 6px 0px 6px;
      font-size: 26px;
      font-weight: 700;
      color: #f46c6c;
    }
  }
}
.qr_list_bot {
  margin-top: 14px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  .qr_bot_icon {
    width: 14px;
  }
  .qr_bot_title {
    font-size: 14px;
    margin-left: 6px;
    color: #7e7e7e;
  }
  .qr_bot_time {
    font-size: 14px;
    .qr_bot_money {
      color: #f46c6c;
    }
  }
}
</style>
